<template>
  <div class="c-aed-userData">
    <div
      class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-start o-field"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--6">
          <span
            class="o-label"
            :title="userDataTranslations.amountOfAssignedAEDs || ''"
            >{{ userDataTranslations.amountOfAssignedAEDs || "" }}</span
          >
        </div>
        <div class="o-grid__item o-grid__item--6">
          <span
            >{{ userDataTranslations.thisUserHas || "" }}
            {{ profileAedCount.totalAeds }}
            {{
              profileAedCount.totalAeds > 1
                ? `${customTranslations.AED}s`
                : customTranslations.AED
            }}.
            <router-link
              :to="{
                query: { fadderId: profileAedCount.profile }
              }"
              class="o-link"
              target="_blank"
              >{{ customTranslations.seeAll || "" }}</router-link
            >
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "c-aed-userData",
  data() {
    return {
      section: "userData",
      name: ""
    };
  },
  computed: {
    ...mapState("translations", {
      userDataTranslations: "userData",
      customTranslations: "custom"
    }),
    ...mapGetters("aed", ["profileAedCount"]),
    ...mapState("aeds", ["parameters"])
  }
};
</script>
<style lang="scss">
.c-aed-userData {
  .o-grid__item {
    display: flex;
    align-items: center;
  }
}
</style>
